import PropTypes from 'prop-types';
import React, {Component} from 'react';
import TabClick from 'modules/common/TabClick';
import {FormattedMessage} from 'react-intl';
import Help from 'theme/assets/images/help.svg';
import {bgBlueLight} from './styles.scss';

class CommunityContent extends Component {
  static propTypes = {
    code_challenge_helper_youtube_id: PropTypes.string,
  };

  render() {
    return (
      <TabClick color={bgBlueLight} title={<FormattedMessage id="community" />}>
        <a
          href="https://community.barmej.com"
          target="_blank"
          rel="noopener noreferrer"
          className="mr3 gray flex items-center pv3"
        >
          <img className="ml2" src={Help} alt="need help" />
          <FormattedMessage id="help_community" />
        </a>
      </TabClick>
    );
  }
}

export default CommunityContent;
